import { render, staticRenderFns } from "./CardProjectAdmin.vue?vue&type=template&id=1b78ac00&"
import script from "./CardProjectAdmin.vue?vue&type=script&lang=js&"
export * from "./CardProjectAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CardProjectAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports